import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import OiFormInput from '../../../../../shared/components/OiForm/OiFormInput';
import Clipboard from '../../../../../shared/components/clipboard';
import { useAppSelector } from '../../../../../shared/infrastructure/store/hooks';

const ApiMerchantCode = () => {
    const {
        toggledAppMode,
        merchantProfile,
        merchantDetails
    } = useAppSelector(({ Merchants }) => Merchants);

    const activeMerchantCode = merchantProfile?.merchantCode || merchantDetails?.[0]?.merchantCode || '';

    const [state, setState] = useState({
        mode: '',
        merchantCode: '',
        copy: null as any
    });

    useEffect(() => {
        setState(prev => ({
            ...prev,
            mode: toggledAppMode,
            merchantCode: activeMerchantCode
        }));
    }, [toggledAppMode, activeMerchantCode]);

    const handleChange = event => {
        const { name, value } = event.target;
        setState({ ...state, [name]: value });
    };

    const handleSubmit = event => {
        event.preventDefault();
    };

    return (
        <div className="content-background">
            <div className="content-background__wrapper">
                <h2 className="settings__header u-half-gradient-bg">Merchant Code</h2>

                <div className="oi-settings__data">
                    <form className="oi-form" onSubmit={handleSubmit}>
                        <div className="oi-form__section  u-margin-top-3_5">
                            <div className="oi-form__group">
                                <OiFormInput
                                    labelClass="oi-form__label-primary"
                                    inputClass="oi-form__input-primary  u-padding-left-1_5  oi-form__reset-password oi-form__input--height4"
                                    name="testPublicKey"
                                    type="text"
                                    label={`${state.mode === 'Test Mode' ? 'Test' : 'Live'} Merchant Code`}
                                    hook="test-public-key"
                                    onChange={handleChange}
                                    placeholder={state.merchantCode ?? ''}
                                    inputValue={state.merchantCode ?? ''}
                                    disable={true}
                                    reference={input => (state.copy = input)}>
                                    <Clipboard reference={state.copy} input={state.merchantCode} />
                                </OiFormInput>
                            </div>
                        </div>

                        <div className="oi-form-help">
                            <div className="oi-form-help__text">Need help with your integration?</div>
                            <a
                                className="oi-form-help__link  u-margin-top-1af"
                                href="https://spay.readme.io/docs/accept-payments"
                                rel="noreferrer"
                                target="_blank">
                                Check out our API documentation
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ApiMerchantCode;
